const DEFAULT_PLAYER_ID = "Default Player";
const DEFAULT_PLAYER_NAME = "Default Player";
const DEFAULT_PLAYER_COUNTRY = "IL";
const DEFAULT_PLAYER_PROFILE_IMAGE_URL = "https://media.appcharge.com/defaults/old-profile.png";
const DEFAULT_PLAYER_AUTH_METHOD = "userToken";

export const generatePlayerData = () => {
  return {
    playerId: DEFAULT_PLAYER_ID,
    playerName: DEFAULT_PLAYER_NAME, 
    playerCountry: DEFAULT_PLAYER_COUNTRY,
    profileImageUrl: DEFAULT_PLAYER_PROFILE_IMAGE_URL,
    authMethod: DEFAULT_PLAYER_AUTH_METHOD
  };
};
